import { createContext } from 'react';

const NewBusinessContext = createContext();

export default NewBusinessContext;
